/**
 * @generated SignedSource<<8b29da5f421f833842cf7cfa4d431b77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlyPreviewStatus = "RUNNING" | "STOPPED" | "STARTING" | "DEGRADED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FlyPreviewsPage_viewer$data = {
  readonly missionControlData: {
    readonly id: string;
    readonly flyPreviews: ReadonlyArray<{
      readonly id: string;
      readonly slug: string;
      readonly branchName: string | null;
      readonly webUrl: string;
      readonly status: FlyPreviewStatus;
      readonly machinesTotal: number;
      readonly machinesRunning: number;
      readonly lastUsedAt: string | null;
      readonly lastUsedKnown: boolean;
      readonly createdAt: string | null;
      readonly deployedAt: string | null;
    }> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
  readonly " $fragmentType": "FlyPreviewsPage_viewer";
};
export type FlyPreviewsPage_viewer$key = {
  readonly " $data"?: FlyPreviewsPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlyPreviewsPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlyPreviewsPage_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MissionControlHeader_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FlyPreview",
          "kind": "LinkedField",
          "name": "flyPreviews",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "branchName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "machinesTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "machinesRunning",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastUsedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastUsedKnown",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deployedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a4fd7cf9f7103542b057ed1163179805";

export default node;
